import i18n from "i18next";

function _changeLanguage(lang: string) {
  i18n.changeLanguage(lang);
}

const Translator = {
  changeLanguage(lang: string) {
    _changeLanguage(lang);
  },

  translate(keys: string | string[], options?: any): string {
    return i18n.t(keys, options);
  },
};

export default Translator;
